import { Alert, Button, Form, FormGroup, Input, Label } from "reactstrap"
import { withTranslation } from "react-i18next"
import { Loading } from "../../components"
import React from "react"
import axios from "axios"
import { connect } from "react-redux"
import { fail, fetchResources } from "../../actions"
import { MultiSelect } from "react-multi-select-component"

class LicenseQuantityForm extends React.Component {
  state = {
    quantity: this.props.license.quantity,
    originalQuantity: this.props.license.quantity,
    updating: false,
    success: false,
    error: false,
    selectedUsers: [],
    scheduledInfo: null,
    autoRenewError: false,
    pendingCancelled: false,
  }

  handleQuantityChange = ({ target }) =>
    this.setState({
      [target.name]: target.value,
      selectedUsers:
        target.value - this.state.originalQuantity <
        this.state.selectedUsers.length
          ? this.state.selectedUsers.slice(
              0,
              target.value - this.state.originalQuantity
            )
          : this.state.selectedUsers,
    })
  componentDidMount() {
    this.props.fetchResources({ resource: "licenseusers" })
  }
  update = async (e) => {
    e.preventDefault()
    this.postQuantity(false)
  }

  postQuantity = async (confirmScheduled) => {
    const { t } = this.props
    this.setState({
      updating: true,
      success: false,
      error: false,
      scheduledInfo: null,
      autoRenewError: false,
      schedulingUnavailable: false,
    })

    try {
      if (this.state.selectedUsers.length === 0) {
        const { data } = await axios.post(
          `/licenses/${this.props.license.id}/quantity`,
          {
            quantity: this.state.quantity,
            ...(confirmScheduled ? { confirmScheduled: true } : {}),
          }
        )
        this.setState({
          success: true,
          scheduledInfo: data && data.scheduled ? data : null,
        })
      } else {
        const { data } = await axios.post(`/tasks/updatequantityandassign`, {
          quantity: this.state.quantity,
          order: {
            order: this.props.license.id,
          },
          userIds: this.state.selectedUsers.map((user) => user.value),
        })
      }
    } catch (err) {
      const resp = err?.response
      if (resp?.status === 409 && resp.data?.requiresConfirmation) {
        this.setState({ updating: false })
        const message = t("_scheduledQuantityChangeConfirm", {
          quantity: resp.data.newQuantity,
          date: new Date(resp.data.effectiveDate).toLocaleDateString(),
        })
        if (window.confirm(message)) {
          this.postQuantity(true)
        }
        return
      }
      if (resp?.status === 409 && resp.data?.autoRenewDisabled) {
        this.setState({ updating: false, autoRenewError: true })
        return
      }
      if (resp?.status === 409 && resp.data?.schedulingUnavailable) {
        this.setState({ updating: false, schedulingUnavailable: true })
        return
      }
      this.props
        .fail(null, err)
        .then(() => this.setState({ error: true, fetching: false }))
    }

    this.setState({ updating: false })
  }

  cancelScheduledChange = async () => {
    this.setState({ updating: true })
    try {
      await axios.delete(
        `/licenses/${this.props.license.id}/scheduled-change`
      )
      this.setState({ updating: false, pendingCancelled: true })
    } catch (err) {
      this.props
        .fail(null, err)
        .then(() => this.setState({ updating: false, error: true }))
    }
  }

  render() {
    const { t, license } = this.props
    const nce = license.productType?.id === "OnlineServicesNCE"
    return (
      <div>
        <h3>{t("_updateQTY")}</h3>
        <Form onSubmit={this.update}>
          <FormGroup>
            <Label for="quantity">{t("_quantity")}</Label>
            <Input
              type="number"
              value={this.state.quantity}
              onChange={this.handleQuantityChange}
              name="quantity"
              id="quantity"
              min={1}
              disabled={this.state.updating || license.status !== "active"}
            />
            {this.state.quantity - this.state.originalQuantity > 0 &&
              !this.state.updating &&
              license.status === "active" && (
                <div className="mt-2">
                  <p className="mt-1">
                    {t("_assignLicensesWhenChangingQuantity")}:
                  </p>
                  <MultiSelect
                    // disable if amount of users selected is greater than the change in quantity
                    options={
                      this.props.licenseusers.fetching
                        ? []
                        : this.props.licenseusers.licenseusers
                            .filter(
                              (user) =>
                                !user.licenses
                                  .map((license) => license.productSku.name)
                                  .includes(this.props.license.offerName)
                            )
                            .map((user) => ({
                              value: user.id,
                              label: user.userPrincipalName,
                              disabled:
                                this.state.quantity -
                                  this.state.originalQuantity <=
                                  this.state.selectedUsers.length &&
                                !this.state.selectedUsers
                                  .map((user) => user.value)
                                  .includes(user.id),
                            }))
                    }
                    isLoading={this.props.licenseusers.fetching}
                    onChange={(selectedUsers) =>
                      this.setState({ selectedUsers })
                    }
                    value={this.state.selectedUsers}
                    hasSelectAll={false}
                    valueRenderer={(selected, _) =>
                      `${selected.length} users selected`
                    }
                  />
                </div>
              )}
          </FormGroup>

          {this.state.success ? (
            <Alert color="success">
              {this.state.scheduledInfo
                ? t("_successMsg_LicQuaScheduled", {
                    quantity: this.state.scheduledInfo.newQuantity,
                    date: new Date(
                      this.state.scheduledInfo.effectiveDate
                    ).toLocaleDateString(),
                  })
                : t("_successMsg_LicQuaUpdate")}
            </Alert>
          ) : this.state.error ? (
            <Alert color="danger">{t("_errorMsg_LicQuaUpdate")}</Alert>
          ) : null}
          {this.state.autoRenewError && (
            <Alert color="warning">{t("_autoRenewDisabledNoSchedule")}</Alert>
          )}
          {this.state.schedulingUnavailable && (
            <Alert color="warning">{t("_scheduledDecreaseUnavailable")}</Alert>
          )}
          {license.scheduledNextTermInstructions?.quantity != null &&
            !this.state.pendingCancelled &&
            !this.state.scheduledInfo && (
              <Alert color="info">
                {t("_scheduledQuantityChangePending", {
                  quantity: license.scheduledNextTermInstructions.quantity,
                  date: license.commitmentEndDate
                    ? new Date(license.commitmentEndDate).toLocaleDateString()
                    : "",
                })}{" "}
                <Button
                  size="sm"
                  color="link"
                  onClick={this.cancelScheduledChange}
                  disabled={this.state.updating}
                >
                  {t("_cancelScheduledChange")}
                </Button>
              </Alert>
            )}
          {this.state.pendingCancelled && (
            <Alert color="success">{t("_scheduledChangeCancelled")}</Alert>
          )}
          {nce && license.status === "active" && (
            <Alert color="info">{t("_nceInfo")}</Alert>
          )}
          {license.status !== "active" && (
            <Alert color="warning">{t("_licenseIsNotActive")}</Alert>
          )}

          {this.state.updating ? (
            <Loading small />
          ) : (
            <Button
              type="submit"
              name="submit"
              id="submit"
              disabled={license.status !== "active"}
            >
              {t("_update")}
            </Button>
          )}
        </Form>
      </div>
    )
  }
}

export default connect(
  (s) => {
    return {
      licenseusers: s.licenseusers,
    }
  },
  { fail, fetchResources }
)(withTranslation()(LicenseQuantityForm))
